module.exports = __webpack_public_path__ + "img/bg8.33d2885d.jpg";